module.exports = __webpack_public_path__ + "img/Gallery_1_06.3e3cec8e.jpeg";